import { useGate as useStatsigGate } from 'statsig-react';

export const useGate = (gateName: string) => {
  return useStatsigGate(gateName);
};
